import React from "react";
import {Route, Switch, useHistory, useLocation} from "react-router-dom";
import {OrderFeedbackProvider} from "./OrderFeedbackProvider";
import {OrderFeedbackRatingPage} from "./OrderFeedbackRatingPage";
import {OrderFeedbackUploadPage} from "./OrderFeedbackUploadPage";

export const OrderFeedbackWrapper = ({match}) => {
    const history = useHistory();
    const location = useLocation();
    const isUploadPage = location.pathname.includes("/upload");

    return (
        <OrderFeedbackProvider match={match} history={history} showBackButton={isUploadPage}>
            <Switch>
                <Route exact path="/order/:orderId/feedback" component={OrderFeedbackRatingPage} />
                <Route exact path="/order/:orderId/feedback/upload" component={OrderFeedbackUploadPage} />
            </Switch>
        </OrderFeedbackProvider>
    );
};
